import { NextPage } from "next"
import { useRouter } from "next/router"
import { useIsRouterReady } from "src/hooks/useIsRouterReady"
import { StandingOrderInvoiceList } from "src/features/standing-order-invoices/components/StandingOrderInvoiceList"
import Head from "next/head"
import { Heading } from "@smooth/design-system-components"
import { DefaultLayout } from "src/components/Layout"

const Page: NextPage = () => {
  const router = useRouter()
  const isRouterReady = useIsRouterReady()
  if (!isRouterReady) return null
  const page = Math.max(Number(router.query.page) || 1, 1)
  const orderId = typeof router.query.orderId === "string" ? router.query.orderId : ""

  return (
    <DefaultLayout>
      <Head>
        <title>口座振替請求 | for Smoother</title>
      </Head>
      <div style={{ height: "calc(100vh - 90px)", overflowY: "auto" }}>
        <div data-smooth-ds className="mx-auto max-w-[900px] px-4 py-6 sm:px-6 lg:px-8">
          <div className="mb-6 flex flex-col gap-2">
            <Heading level={1}>口座振替請求</Heading>
          </div>
          {/* 検索語が変わったら入力欄の初期値も合わせるため、key で作り直す */}
          <StandingOrderInvoiceList key={orderId} page={page} orderId={orderId} />
        </div>
      </div>
    </DefaultLayout>
  )
}

export default Page
